import { reduceProductsResponse } from 'pricing-pages-lib/reducers/Products';
import Raven from 'raven-js';
import { FetchProductsRequestTypes } from '../actions/ProductsActions';
const initialState = {
  skuIdToProductVersion: {},
  skuMap: {},
  productApiNameMapToProduct: {},
  productLineLevelToProduct: {},
  quantityPackApiNameToProduct: {},
  rawProductList: [],
  productMap: {},
  apiNameToProductId: {},
  productLineLevelToProductId: {},
  quantityPackApiNameToProductId: {}
};
const AbstractedProducts = (state = initialState, {
  type,
  payload
}) => {
  switch (type) {
    case FetchProductsRequestTypes.RECEIVE:
      {
        if (!payload) {
          return state;
        }
        const {
          data
        } = payload;
        if (!Array.isArray(data)) {
          Raven.captureException(new Error('Invalid response from Product Abstraction endpoint'), {
            extra: {
              data: payload === null || payload === void 0 ? void 0 : payload.data
            }
          });
        }
        return reduceProductsResponse(data);
      }
    default:
      return state;
  }
};
export default AbstractedProducts;